import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const MinValue = ({
  minAmount,
  currency,
  className,
  style,
  label = "Min amount",
  ...props
}) => /* @__PURE__ */ React.createElement("span", { ...props, className: cx(styles.text, className), style }, label, " ", /* @__PURE__ */ React.createElement("img", { className: styles.image, src: currency, alt: "" }), " ", /* @__PURE__ */ React.createElement("span", null, minAmount));
MinValue.displayName = "MinValue";

export { MinValue };
//# sourceMappingURL=index.js.map
